const angular = require('angular');
const { notificationMessageComponentDefinition } = require('./notification-message.component');

angular.module('wowApp.shop')
    .component('wowNotificationMessage', notificationMessageComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/notificationmessage/index.js